$(function () {
  mem.showPage('index');
});
